import * as i0 from "@angular/core";
var DataTableMapperService = /** @class */ (function () {
    function DataTableMapperService() {
    }
    DataTableMapperService.prototype.convertMaintenanceDataToDataTable = function (maintenanceData) {
        return {
            companyId: maintenanceData.companyId,
            companyName: maintenanceData.name,
            table: {
                maintenancePerSituation: this.getMaintenancePerSituationData(maintenanceData),
                maintenancePerAverageTime: this.getMaintenancePerAverageTimeData(maintenanceData),
                maintenancePerVolume: this.getMaintenancePerVolumeData(maintenanceData),
                ratings: this.getRatingsData(maintenanceData),
                responseDeadline: this.getResponseDeadlineData(maintenanceData),
                solutionDeadline: this.getSolutionDeadLineData(maintenanceData)
            }
        };
    };
    DataTableMapperService.prototype.getMaintenancePerSituationData = function (maintenanceData) {
        return {
            total: maintenanceData.totalMaintenance,
            requestedItems: maintenanceData.status.requested,
            onNegotiationItems: maintenanceData.status.onNegotiation,
            pendingItems: maintenanceData.status.pending,
            scheduledItems: maintenanceData.status.scheduled,
            inProgressItems: maintenanceData.status.inProgress,
            doneItems: maintenanceData.status.done,
            reportedItems: maintenanceData.status.reported,
            canceledItems: maintenanceData.status.canceled
        };
    };
    DataTableMapperService.prototype.getMaintenancePerAverageTimeData = function (maintenanceData) {
        return {
            pending: maintenanceData.statusInterval.pending,
            requested: maintenanceData.statusInterval.requested,
            onNegotiation: maintenanceData.statusInterval.onNegotiation,
            scheduled: maintenanceData.statusInterval.scheduled,
            inProgress: maintenanceData.statusInterval.inProgress,
            reported: maintenanceData.statusInterval.reported
        };
    };
    DataTableMapperService.prototype.getMaintenancePerVolumeData = function (maintenanceData) {
        return {
            acceptedTotal: maintenanceData.volumeCount.acceptedCount.value,
            acceptedPercentage: maintenanceData.volumeCount.acceptedCount.percent,
            refusedTotal: maintenanceData.volumeCount.refusedCount.value,
            refusedPercentage: maintenanceData.volumeCount.refusedCount.percent,
            doneTotal: maintenanceData.volumeCount.completedCount.value,
            donePercentage: maintenanceData.volumeCount.completedCount.percent,
            notDoneTotal: maintenanceData.volumeCount.incompleteCount.value,
            notDonePercentage: maintenanceData.volumeCount.incompleteCount.percent
        };
    };
    DataTableMapperService.prototype.getRatingsData = function (maintenanceData) {
        return {
            ratingsTotal: maintenanceData.ratingsCount.totalCount,
            negative: maintenanceData.ratingsCount.negativeCount,
            positive: maintenanceData.ratingsCount.positiveCount,
            totalAverage: maintenanceData.ratingsCount.averageRating
        };
    };
    DataTableMapperService.prototype.getResponseDeadlineData = function (maintenanceData) {
        return {
            inDeadline: maintenanceData.averageDeadlines.fistVisitOnTimeCount,
            timeAverageWithDeadline: maintenanceData.averageDeadlines.averageResponseTimeInDays,
            timeAverageTotal: maintenanceData.statusInterval.responseAverage,
            outOfDeadline: maintenanceData.averageDeadlines.fistVisitOutTimeCount,
            inDeadLinePercentage: maintenanceData.averageDeadlines.responseOnTimePercentage
        };
    };
    DataTableMapperService.prototype.getSolutionDeadLineData = function (maintenanceData) {
        return {
            inDeadline: maintenanceData.averageDeadlines.closedOnTimeCount,
            timeAverageWithDeadline: maintenanceData.averageDeadlines.averageCloseTimeInDays,
            timeAverageTotal: maintenanceData.statusInterval.solutionAverage,
            outOfDeadline: maintenanceData.averageDeadlines.closedOutTimeCount,
            inDeadLinePercentage: maintenanceData.averageDeadlines.closedOnTimePercentage,
        };
    };
    DataTableMapperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DataTableMapperService_Factory() { return new DataTableMapperService(); }, token: DataTableMapperService, providedIn: "root" });
    return DataTableMapperService;
}());
export { DataTableMapperService };
